import { ColorEnum } from '@/constants/color'
import Typography from '@/features/ui/typography'
import { FC } from 'react'

interface TextProps {
    children: string
}

const Text: FC<TextProps> = ({ children }) => {
    return (
        <Typography.Description
            font="medium"
            numberOfLines={2}
            style={{ color: ColorEnum.JET_500 }}
        >
            {children}
        </Typography.Description>
    )
}

export default Text
